import Api from 'redux/api';

export default class useAPI extends Api {
  getDataFromApi = async url => {
    try {
      const apiData = await this.get(`${url}`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error
      };
    }
  };

  postDataFromApiAction = async (url, payload) => {
    try {
      const apiData = await this.post(`${url}`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error
      };
    }
  };

  updateDataFromApiAction = async (url, payload) => {
    try {
      const apiData = await this.put(`${url}`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error
      };
    }
  };

  updatePartialDataFromApiAction = async (url, payload) => {
    try {
      const apiData = await this.patch(`${url}`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error
      };
    }
  };

  deleteDataFromApiAction = async (url, payload) => {
    try {
      const apiData = await this.delete(`${url}`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error
      };
    }
  };

  patchDataUpdateFromAPiAction = async (url, payload) => {
    try {
      const apiData = await this.patch(`${url}`, payload);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error
      };
    }
  };
}
